import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import './HomeHeader.css';

function HomeHeader() {
  const [location, setLocation] = useState('Loading location...');
  const [error, setError] = useState(null);
  const navigate = useNavigate();

  useEffect(() => {
    if (navigator.geolocation) {
      navigator.geolocation.getCurrentPosition(
        (position) => {
          fetchLocationName(position.coords.latitude, position.coords.longitude);
        },
        (err) => {
          setError('Unable to retrieve location');
          console.error('Geolocation error:', err);
          setLocation('Location unavailable');
        }
      );
    } else {
      setError('Geolocation not supported');
      setLocation('Location unavailable');
    }
  }, []);

  const fetchLocationName = async (lat, lng) => {
    try {
      const response = await fetch(
        `https://api.bigdatacloud.net/data/reverse-geocode-client?latitude=${lat}&longitude=${lng}&localityLanguage=en`
      );
      const data = await response.json();
      setLocation(data.city || data.locality || 'Your location');
    } catch (err) {
      console.error('Reverse geocoding error:', err);
      setLocation('Your location');
    }
  };

  return (
    <header className="header">
      <div className="header__links">
        <div className="header__links_left">
          {/* Example Logo */}
          {/* <a href='/'><img
            src="/logo.png"
            alt="Anyworq Logo"
            className='head-logo'
            loading="lazy" 
          /></a> */}

          {error ? (
            <span className="location-error">{location}</span>
          ) : (
            <span className="location">
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="16"
                height="16"
                viewBox="0 0 24 24"
                fill="none"
                stroke="currentColor"
                strokeWidth="2"
                strokeLinecap="round"
                strokeLinejoin="round"
              >
                <path d="M21 10c0 7-9 13-9 13s-9-6-9-13a9 9 0 0 1 18 0z"></path>
                <circle cx="12" cy="10" r="3"></circle>
              </svg>
              {location}
            </span>
          )}
        </div>
        <div className="header__links_right">
          <button 
            className="header__button"
            onClick={() => navigate(`/categories/realestate`)}
          >
            Log In
          </button>

          <button 
            className="header__button"
            onClick={() => navigate(`/categories/realestate`)}
          >
            Sign Up
          </button>
        </div>
      </div>
    </header>
  );
}

export default HomeHeader;
